import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { TieredMenu } from 'primeng/tieredmenu';
import { MxBaseComponent } from 'src/app/core/base/mx.base-component';
import {
  MxMenuType,
  MxTableColumn,
  MxTableOperationItems,
} from 'src/app/shared/domains/common/interfaces';

@Component({ standalone: false,
  selector: '[mx-table-body]',
  templateUrl: './mx.table-body.component.html',
  styleUrls: ['./mx.table-body.component.scss'],
})
export class MxTableBodyComponent extends MxBaseComponent implements OnInit {
  @Input() columns: MxTableColumn[];
  @Input() columnDefaultWidth: number;
  @Input() rowData: any;
  @Input() isOperation: boolean;
  @Input() operationItems: MxTableOperationItems[];

  @Output() rowDataChange: EventEmitter<any> = new EventEmitter<any>();

  speedDialItems: MenuItem[];
  visibleSpeedDial: boolean;
  fixButtonItems: MxTableOperationItems[];
  operationItemsWidth: number;

  tieredItems: MenuItem[];
  visibleTiered: boolean;

  tieredMenuOpenCommand = (event: any) =>this.openTieredMenu(event);

  @ViewChild('tieredMenu') tieredMenu: TieredMenu;

  ngOnInit() {
    this.speedDialItems = [];
    this.tieredItems = [];
    this.fixButtonItems = [];
    if (this.operationItems) {
      this.operationItems.forEach((item) => {
        if (item.type !== undefined) {
          if (item.type === MxMenuType.SpeedDial) {
            this.speedDialItems.push({
              tooltipOptions: {
                tooltipLabel: item.label,
                tooltipPosition: 'top',
              },
              icon: item.icon,
              command: item.command,
            });
          }

          if (item.type === MxMenuType.Tiered) {
            this.tieredItems.push({
              label: item.label,
              icon: item.icon,
              command: item.command,
            });
          }
        } else {
          this.fixButtonItems.push(item);
        }
      });

      this.visibleSpeedDial = this.speedDialItems.length !== 0;
      this.visibleTiered = this.tieredItems.length !== 0;

      this.operationItemsWidth =
        40 *
        (this.fixButtonItems.length +
          (this.visibleSpeedDial && this.visibleTiered
            ? 2
            : this.visibleSpeedDial || this.visibleTiered
            ? 1
            : 0));
    }
  }

  openTieredMenu(event: any){
    this.tieredMenu.toggle(event);
  }
}
